import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import {
    ShippingDestination,
    cropList,
    WeightUnit,
    selectedSalesResultCropItems,
    SalesResultByCopListDetails,
    ShippingDestinationList
} from "@/types/Component";
import moment from "moment";
import { CsvDownload } from "@/types/APIResponse";
import HorizontalBarChart from "@/assets/common/HorizontalBarChart/HorizontalBarChart.vue";
import EmptyGraphMessage from '@/assets/common/AggregationFunction/EmptyGraphMessage/EmptyGraphMessage.vue';
import { toCamel } from "snake-camel";
type WeightUnits = {
  weightUnits: WeightUnit[];
};
@Component({
    components: {
        HorizontalBarChart,
        EmptyGraphMessage,
    },
})
export default class SalesResultByCrop extends Vue {
    baseUrl = "/sales_result_by_crop";
    private weightUnitName: any = "";
    cropDetails = [] as cropList;
    private weightUnits: WeightUnit [] = [];
    private selectedCropId = null;
    private selectedDestinationId = null;
    private selectedWeightUnitId = null;
    private startDate = this.currentYearStartDate();
    private endDate = this.currentYearEndDate();
    private selectedStartDate: any = "";
    private selectedEndDate: any = "";
    private unitType :any = "";
    private selectUnit = false;
    private dateRange: any = "";
    private cropName: any = "";
    selectScreenManagement = "/graphScreenManagement";
    private shippingDestinationList = [] as ShippingDestinationList[];
    private selectedShippingDestinationName:any ="" 
     salesResultByCropListDetails =[] as SalesResultByCopListDetails[] ;
    private selectedSalesResultCropItems = {} as selectedSalesResultCropItems; 
    private cropDestinationNames :any =[]
    private totalAmounts: number[] = [];
    private totalDisposalQuantities:number[] = [];
    private totalQuantities: number[] = [];
    private isButtonDisabled = false;
    private groupNamePrefix = "【"
    private groupNameSuffix = "】計"
    private hideSalesAmount = true;
    private hideNumberOfSales = true;
    private hideNumberOfWaste = true;
    private chartData: any = {};
    private options: any = {};
    private plugins:any=[]
    private dataEmptyFlag = false;
    includeHiddenFlag = false;

    created() {
      this.getWeightUnits();
      this.getCrops();
      this.getShippingDestinations();
      this.getSalesResultsByCrop();
      this.selectedStartDate = this.startDate;
      this.selectedEndDate = this.endDate;
      this.dataEmptyFlag = true;
    }

    // get sales result by crops list details
    getSalesResultsByCrop() {
      this.$apiClient.doRequest("get", this.baseUrl)
        .then((res) => {
          if (!res.weightUnitNullCheck) {
            if (res.salesResultsListView) {
              this.salesResultByCropListDetails = res.salesResultsListView;
              this.selectedSalesResultCropItems = res?.salesResultFilterView;
              if (this.selectedSalesResultCropItems !== null) {
                this.defaultSelectedItems(this.selectedSalesResultCropItems);
              }
              this.unitType = this.selectedWeightUnitId ? '' : null;
              this.selectUnit = this.selectedWeightUnitId !== null;
              if (this.salesResultByCropListDetails.length) {
                this.arrayPushFunction(this.salesResultByCropListDetails);
                this.hideSalesAmount = true
                this.hideNumberOfSales = true
                this.hideNumberOfWaste = true
              }
              else{
                this.dataEmptyFlag = false;
              }
            }
          }else {
            this.selectedWeightUnitId = null
            window.alert("1単位あたりの重量を設定してください。");
          }
          this.unitType = this.selectedWeightUnitId ? '' : null;
          this.selectUnit = this.selectedWeightUnitId !== null;
          if ((this.startDate > this.endDate) || (this.startDate === '' && this.endDate === '') || (this.startDate === '' && this.endDate !== '') 
            || (this.startDate !== '' && this.endDate === '')) {
            this.isButtonDisabled = true;
            this.salesResultByCropListDetails=[];
          }else{
            this.isButtonDisabled = false;
          } 
        })
    }

    //To append default selected items
    defaultSelectedItems(selectedItem:any){
    this.selectedCropId =selectedItem.cropId;
    this.selectedDestinationId =selectedItem.shippingDestinationId;
    this.selectedWeightUnitId = selectedItem.weightUnitId;
    this.weightUnitName = selectedItem.weightUnitName;
    this.startDate = selectedItem.displayFromDate ?selectedItem.displayFromDate : "" ;
    this.endDate = selectedItem.displayToDate ? selectedItem.displayToDate :  "";
    this.selectedStartDate=selectedItem.displayFromDate;
    this.selectedEndDate=selectedItem.displayToDate;
    this.includeHiddenFlag = selectedItem.includeHiddenFlag
    }

 // Array push to sum group and overall and individual destination totals
 private arrayPushFunction(salesResultCropDetails: any[]) {
    let overallTotalAmount = 0;
    let overallTotalQuantity = 0;
    let overallTotalDisposalQuantity = 0;
    const pushCropGroups = salesResultCropDetails.reduce((result, item) => {
      const cropGroupName = item.cropName;
      // Check if there's already a group with the same name
      const existingGroup = result.find((group:any) => group.groupName === cropGroupName);
      if (existingGroup) {
        existingGroup.destinations.push(item);
      } else {
        // Create a new group
        const newGroup = {
          groupName: cropGroupName,
          destinations: [item],
        };
        result.push(newGroup);
      }
      return result;
    }, []);
    pushCropGroups.map((item :any)=>{
      const groupName = item.groupName || "作目未選択";
      this.cropDestinationNames.push(this.groupNamePrefix + groupName + this.groupNameSuffix)
      // group destination total 
      const groupTotalQuantity = item.destinations.reduce((total: any, destination: any) => total + (destination.totalSalesQuantity), 0);
      const groupTotalDisposalQuantity = item.destinations.reduce((total: any, destination: any) => total + (destination.totalDisposalQuantity), 0);
      const groupTotalAmount = item.destinations.reduce((total: any, destination: any) => total + destination.totalSalesAmount, 0);
      this.totalQuantities.push(groupTotalQuantity);
      this.totalDisposalQuantities.push(groupTotalDisposalQuantity);
      this.totalAmounts.push(groupTotalAmount);
      // individual destination total 
      item.destinations.map((item:any)=>{
      this.cropDestinationNames.push(item.destinationName)
      this.totalAmounts.push(item.totalSalesAmount || 0);
      this.totalQuantities.push(item.totalSalesQuantity ||0);
      this.totalDisposalQuantities.push((item.totalDisposalQuantity||0));
      overallTotalQuantity += (item.totalSalesQuantity||0);
      overallTotalDisposalQuantity += item.totalDisposalQuantity || 0;
      overallTotalAmount += item.totalSalesAmount;
      });
      });
     // overAll destination total 
      if(!this.selectedCropId){
      this.cropDestinationNames.push("総合計")
      this.totalAmounts.push(overallTotalAmount)
      this.totalQuantities.push(overallTotalQuantity)
      this.totalDisposalQuantities.push(overallTotalDisposalQuantity)
      }
      this.dataEmptyFlag=true
      this.setChartDetails();
}

    getCrops() {
        this.$apiClient.doRequest("get", `/crops/cropBytenentId`).then(res => {
            this.cropDetails = res.crops;
            this.cropDetails.sort((a:any, b:any) => a.name.localeCompare(b.name));
        });
    }

    getShippingDestinations() {
        this.$apiClient.doRequest('get', `/admin/shipping_destinations?with_hidden=true`).then(ret => {
        this.shippingDestinationList = ret.shipping_destinations;
        this.selectedShippingDestinationName=  this.shippingDestinationList.find(item=>item.id==this.selectedDestinationId)?.name
        })
    }

    getWeightUnits() {
        this.$apiClient
            .doRequest("get", "/weight_units?with_hidden=true")
            .then((res) => {
                this.weightUnits = (toCamel(res) as WeightUnits).weightUnits;
            });
    }

    postSalesResultByCropScreenFilter(flag = true) {
        const params = {
            cropId: this.selectedCropId,
            destinationId: this.selectedDestinationId,
            weightUnitId: this.selectedWeightUnitId,
            startDate: this.startDate,
            endDate: this.endDate,
            screenName: "SALESRESULTBYCROP",
            includeHiddenFlag: this.includeHiddenFlag
        };
        this.$apiClient
            .doRequest("post", `${this.selectScreenManagement}`, params)
            .then((res) => {   
              if (flag) {
                this.totalAmounts = [];
                this.totalDisposalQuantities = [];
                this.totalQuantities = [];
                this.cropDestinationNames = []; 
                this.getSalesResultsByCrop();
              }
            });
    }

     // roundUp value function
  roundUpNumber(num: number): number {
    const stringValue = num.toString();
    const firstTwoDigits = parseInt(stringValue.substring(0, 2));
    const restOfTheNumber = parseInt(stringValue.substring(2));
  if (restOfTheNumber === 0) {
    return num; 
  }
  const roundedNum = Math.pow(10, Math.floor(Math.log10(num))) * Math.ceil(num / Math.pow(10, Math.floor(Math.log10(num))));
  if (roundedNum === num) {
    return num; 
  }
  return roundedNum;
  }

  // chart data details   
  private setChartDetails():void {
      const maxAmount = Math.max(...this.totalAmounts) * 1.2;
      const roundedMaxAmount =this.roundUpNumber(maxAmount);
      const maxSalesQuantity = Math.max(...this.totalQuantities) * 1.2;
      const maxDisposalQuantity =Math.max(...this.totalDisposalQuantities) * 1.2
      const roundedMaximumQuantity = (maxDisposalQuantity > maxSalesQuantity ) ? this.roundUpNumber(maxDisposalQuantity) :this.roundUpNumber(maxSalesQuantity);
      this.chartData={
        labels:this.cropDestinationNames, 
        datasets: [
          this.salesAmountDataset,
          this.numberOfSalesDataset,
          this.numberOfWasteDataset,
        ]
      }
      //plugin to change backround color
      this.plugins = [{
        // Acheive the background color before chart draw 
        beforeDraw: (chart:any,args:any,pluginOption:any)=>{
          const ctx = chart.ctx;
          const chartArea = chart.chartArea;
          const yLabels = chart.scales['y-axis-0'].ticks; 
          const groupIndices = [] as any; 
          // Find the index of the 'group' labels to draw backround
          yLabels.map((label:any, index:any) => {
            if (label.includes('計')) {
              groupIndices.push(index);
            }
          });
          const backgroundColor = "#e9edef"; 
          // Loop through the title indices and highlight the corresponding areas
          groupIndices.map((index:any) => {
            const y = chartArea.top + (index * (chartArea.bottom - chartArea.top) / yLabels.length);
            ctx.fillStyle = backgroundColor;
            ctx.fillRect(chartArea.left-200, y, chartArea.right - chartArea.left+200, (chartArea.bottom - chartArea.top) / yLabels.length);
          });
        },
        afterDraw: (chart:any)=> {
          const ctx = chart.ctx;
          const yScale = chart.scales['y-axis-0'];
          const yPos = yScale.top;
          ctx.save();
          ctx.textBaseline = 'middle';
          ctx.font = 'bold 12px  arial';
          ctx.fillStyle = 'black';
          ctx.fillText(`単位:${this.weightUnitName}`, yScale.left -160  , yPos -20)
          ctx.restore();
        }
      }]
      
      this.options={
          responsive: true,
          maintainAspectRatio: false,
          plugins:{
            datalabels: 
            {
              color: "black",
              textAlign: "center",
              align:'right',
              anchor:'end',
              formatter:(value:any,context:any)=>{
                return context.dataset.xAxisID == 'A' ?  value?.toLocaleString('ja-jp') + "円" : value?.toLocaleString('ja-jp') + this.weightUnitName 
              },
              font: {
                size: 13
              } 
            }
          },
          scales:{
            xAxes:[
              {
                id:"B",
                beginAtZero:true,
                position:"bottom",
                ticks:{
                  stepSize :roundedMaximumQuantity / 5,
                  suggestedMin:0,
                  suggestedMax: roundedMaximumQuantity,
                  fontColor:"black",
                  callback:(value:any,index:any,values:any)=>{
                      return (value? value.toLocaleString('ja-JP'): 0) + this.weightUnitName
                  }
                },
              },
              {
                id:"A",
                type:"linear",
                position:"top",
                ticks:{
                  stepSize : roundedMaxAmount ? roundedMaxAmount / 5 : 1,
                  suggestedMin:0,
                  suggestedMax:roundedMaxAmount ? roundedMaxAmount : 5,
                  fontColor:"black",
                  callback:(value:any,index:any,values:any)=>{
                    return (value ? value.toLocaleString('ja-JP') : 0) + "円"
                  }
                },
              },
            ],
            yAxes:[
              {  
                gridLines:{
                  display: true,
                  drawBorder:false,
                }, 
                ticks:{
                  mirror: true,
                  padding:180,
                  fontColor:"black",
                  fontSize:13,
                  callback:(value:any,index:any,values:any)=>{
                    if(value.includes(this.groupNameSuffix)){
                      value = value.length>18 ? value.split("】")[0].substring(0,15)+"..."+"】"+value?.split("】")[1]:value
                    }else{
                      value = value.length>18 ?value.substring(0,15)+"...":value;
                    }
                    return value;
                  }
                }
              },
            ],
            },
            legend: {
              display: false, // Hide the legend
            },
                    responsiveAnimationDuration: 0,
                    animation: {
                        duration: 0, // general animation time
                    },
                    hover: {
                        animationDuration: 0,
                    },
                    tooltips: {
                        mode: "nearest",
                        callbacks:{
                          title:(value:any,data:any)=>{
                           return data.datasets[value[0].datasetIndex].label 
                          },
                          label: (tooltipItem: any, data: any)=>{
                             const toolTipValue = Number(tooltipItem.value)
                            return data.datasets[tooltipItem.datasetIndex].xAxisID === 'A' ? toolTipValue?.toLocaleString('ja-JP')+ "円":toolTipValue?.toLocaleString('ja-JP') + this.weightUnitName;
                          }
                        }
                    },
                    layout: {
                        padding: {
                           left: 180,
                        },
                    },
            }
          }

    private get salesAmountDataset() {
      return {
        label: '売上金額',
        xAxisID: 'A',
        data: this.totalAmounts,
        borderColor: '#71A0D8',
        backgroundColor: '#71A0D8',
      };
    }

    private get numberOfSalesDataset() {
      return {
        label: '売上数',
        borderColor: '#71D8A8',
        backgroundColor: '#71D8A8',
        xAxisID: 'B',
        data:this.totalQuantities,
      };
    }

    private get numberOfWasteDataset() {
      return {
        label: '廃棄数',
        borderColor: '#D8C471',
        backgroundColor: '#D8C471',
        xAxisID: 'B',
        data: this.totalDisposalQuantities,
      };
    }

    private get visibleDatasets() {
      return [
        ...(this.hideSalesAmount ? [this.salesAmountDataset] : []),
        ...(this.hideNumberOfSales ? [this.numberOfSalesDataset] : []),
        ...(this.hideNumberOfWaste ? [this.numberOfWasteDataset] : []),
      ];
    }

    private syncVisibleDatasets() {
      this.chartData = {
        ...this.chartData,
        datasets: this.visibleDatasets,
      };
    }

    private get visibleGraphItemCount() {
      return [
        this.hideSalesAmount,
        this.hideNumberOfSales,
        this.hideNumberOfWaste,
      ].filter(Boolean).length;
    }

    //checkBox hide for amount,quantities,disposalQuantities
    @Watch("hideSalesAmount")
    private hideBlue() {
        this.syncVisibleDatasets();
    }

    @Watch("hideNumberOfSales")
    private hideGreen() {
        this.syncVisibleDatasets();
    }

    @Watch("hideNumberOfWaste")
    private hideYellow() {
        this.syncVisibleDatasets();
    }

     //LEGEND CICK FUNCTION  
  legendClick (datasetIndex :any,label:any){
    switch (datasetIndex) {
        case 0:
          this.hideSalesAmount = !this.hideSalesAmount;
        break;
        case 1:
            this.hideNumberOfSales = !this.hideNumberOfSales;
        break;
        case 2:
            this.hideNumberOfWaste = !this.hideNumberOfWaste;
        break;
        default:
            window.alert(
              "リクエストに失敗しました。\n" +
              "リクエスト内容が不正です。"
            );
    }
      if (this.hideSalesAmount && datasetIndex === 0) {
          this.hideSalesAmount = true;
      } else if(this.hideSalesAmount && label ==="売上金額") {
          this.hideSalesAmount = false;
      }
      if (this.hideNumberOfSales && datasetIndex === 1) {
            this.hideNumberOfSales = true;
      } else if(this.hideNumberOfSales && label ==="売上数") {
            this.hideNumberOfSales = false;
      }
      if (this.hideNumberOfWaste && datasetIndex === 2) {
            this.hideNumberOfWaste = true;
      } else if(!this.hideNumberOfWaste && label ==="廃棄数") {
            this.hideNumberOfWaste = false;
      }
}
   
    private disableUnitselect(flag: boolean) {
        if (flag === true) {
            this.selectUnit = true;
        } else {
            this.selectedWeightUnitId = null;
            this.selectUnit = false;
            this.postSalesResultByCropScreenFilter();
        }
    }

    get setStyle() {
        if (this.cropDestinationNames.length > 1) {
            const rowHeight = this.visibleGraphItemCount === 3 ? 100 : this.visibleGraphItemCount === 2 ? 75 : 50;
            let height = this.cropDestinationNames.length * rowHeight + 130;
            const CANVAS_HEIGHT_LIMIT = 32767;
            height =
                height > CANVAS_HEIGHT_LIMIT ? CANVAS_HEIGHT_LIMIT : height;
            return {
                position: "relative",
                width: "calc(100% - 10px)",
                height: height + "px",
            };
        }
    }

    currentYearStartDate() {
        const currentYear = new Date().getFullYear();
        return `${currentYear}-01-01`;
    }

    currentYearEndDate() {
        const currentYear = new Date().getFullYear();
        return `${currentYear}-12-31`;
    }

    private getDateRange() {
        const startDate = moment(this.startDate);
        const endDate = moment(this.endDate);
        const result = [];
        const current = startDate.clone();
        while (current <= endDate) {
            result.push(current.format("YYYY-MM-DD"));
            current.add(1, "day");
        }
        return result;
    }
 
    // date navigartion forward and backwrad
    private dateNavigation(action: string) {
        this.validateDates()
        if(this.isButtonDisabled == false){
        this.dateRange = this.getDateRange();
        const startDate = moment(this.startDate);
        const endDate = moment(this.endDate);
        const newStartDate =action === "next"? startDate.clone().add(this.dateRange.length, "day")
                      .format("YYYY-MM-DD")
                : startDate
                      .clone()
                      .subtract(this.dateRange.length, "day")
                      .format("YYYY-MM-DD");
        const newEndDate = moment(newStartDate)
            .add(this.dateRange.length - 1, "day")
            .format("YYYY-MM-DD");
        this.startDate = newStartDate;
        this.endDate = newEndDate;
        this.postSalesResultByCropScreenFilter()
    } else {
      this.isButtonDisabled = false
    }
  }

    private validateDates() {
        if (!this.startDate || !this.endDate) return;
        if (this.startDate > this.endDate) {
            this.startDate = this.selectedStartDate;
            this.endDate = this.selectedEndDate;
            this.isButtonDisabled = true;
        } else {
            this.isButtonDisabled = false;
            this.selectedStartDate = this.startDate;
            this.selectedEndDate = this.endDate;
        }
    }

    // csv export for salesResultByCrop Screen 
     exportCsv() {
      this.cropName =this.cropDetails.find((item: any) => item.id === this.selectedCropId)?.name || null;
      this.weightUnitName = this.weightUnits.find((item) => item.id === this.selectedWeightUnitId)?.name;
          this.$apiClient
              .getRequest(
                  `${this.baseUrl}/csv_export?destination_name=${
                      this.selectedShippingDestinationName || ""
                  }&crop_name=${this.cropName || ""}&units=${this.weightUnitName || ""}&start_date=${
                      this.startDate
                  }&end_date=${this.endDate}`
              )
              .then((res: CsvDownload) => {
                  this.$apiClient.csvDownload(res);
              });
    }

  get filterWeightUnits() {
    return this.includeHiddenFlag ? this.weightUnits : this.weightUnits.filter(wu => this.selectedWeightUnitId == wu.id || !wu.isHidden);
  }

  get filterShippingDestinationList() {
    return this.includeHiddenFlag ? this.shippingDestinationList : this.shippingDestinationList.filter(s => this.selectedDestinationId == s.id || !s.is_hidden);
  } 
}
